import React from "react";

import usePageContent from "../../hooks/usePageContent";
import EditableSection from "../../components/CMS/EditableSection";
import "../../app/styles/students.css";

import StudentsHero from "./StudentsHero";
import StudentAchievementStrip from "./StudentAchievementStrip";
import AboutTestimonialsSection from "./AboutTestimonialsSection";
import AboutJourneySection from "./AboutJourneySection";
import StudentAchievementTimeline from "./StudentAchievementTimeline";
import AboutGlobalCommunitySection from "./AboutGlobalCommunitySection";
import AboutAchievementSection from "./AboutAchievementSection";


import GenericSectionEditor from "../../components/CMS/editors/GenericSectionEditor";


const AchievementPage = ({ user }) => {

    const {
        get,
        loading,
        error,
        refresh
    } = usePageContent("achievements");


    const editable = !!user;


    if (loading) {
        return (
            <div className="container">
                <p>Loading...</p>
            </div>
        );
    }


    if (error) {
        return (
            <div className="container">
                <p>
                    Failed to load founders page.
                </p>
            </div>
        );
    }


    return (
        <section className="students-page">
            <EditableSection
                uniqueId="achievement-intro"
                title="A Journey from Engineering to"
                data={get("intro")}
                Display={StudentsHero}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
             <EditableSection
                uniqueId="achievement-achiv"
                title="A Journey from Engineering to"
                data={get("achiv")}
                Display={StudentAchievementStrip}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="achievement-achievement"
                title="A Journey from Engineering to"
                data={get("achievement")}
                Display={AboutAchievementSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
           <EditableSection
                uniqueId="achievement-testi"
                title="A Journey from Engineering to"
                data={get("testi")}
                Display={AboutTestimonialsSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
             <EditableSection
                uniqueId="achievement-journey"
                title="A Journey from Engineering to"
                data={get("journey")}
                Display={AboutJourneySection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            /> 
            <EditableSection
                uniqueId="achievement-timeline"
                title="A Journey from Engineering to"
                data={get("timeline")}
                Display={StudentAchievementTimeline}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            /> 
            <EditableSection
                uniqueId="achievement-global"
                title="A Journey from Engineering to"
                data={get("global")}
                Display={AboutGlobalCommunitySection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
        </section>
    );
};


export default AchievementPage;